import { startSubscriptionNow } from "@/services/api/Stripe";
import { DialogClose } from "@radix-ui/react-dialog";
import { useState } from "react";
import toast from "react-hot-toast";
import { Button } from "./ui/button";
import { Dialog, DialogContent } from "./ui/dialog";
import ModalFullSubscription from "./modal/ModalFullSubscription";

export default function ModalActivateSubscription({
  isOpen,
  setIsOpen,
  planSubscription,
}) {
  const [loadingStartSubsNow, setLoadingStartSubsNow] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);

  const startNowSubscription = async () => {
    if (loadingStartSubsNow) return;
    setLoadingStartSubsNow(true);

    try {
      const res = await startSubscriptionNow({
        subscriptionId: planSubscription?.subscription_detail?.id,
      });
      setOpenSuccess(true);
      setLoadingStartSubsNow(false);
    } catch (error) {
      console.error(error);
      toast.error(
        error.response?.data?.error ||
          "An error occurred while activating your subscription."
      );
      setLoadingStartSubsNow(false);
    }
  };

  return (
    <>
      <ModalFullSubscription isOpen={openSuccess} setIsOpen={setOpenSuccess} />
      <Dialog
        open={loadingStartSubsNow ? true : isOpen}
        onOpenChange={setIsOpen}
      >
        <DialogContent
          className='gap-0 p-0 bg-white divide-y divide-gray-200 text-background'
          hideCloseButton
        >
          <div className='p-4'>
            <p className='text-lg font-semibold'>
              Activate Your Full Subscription?
            </p>
            <p className='mt-1.5 text-sm opacity-60'>
              You are about to activate your full subscription. This will end
              your trial and provide you with all benefits without limits.
            </p>
          </div>
          <div className='flex gap-2 px-4 py-3'>
            <DialogClose asChild>
              <Button
                type='button'
                variant='outline'
                className='border-gray-300 shadow-sm hover:bg-gray-50 bg-white'
                disabled={loadingStartSubsNow}
              >
                Cancel
              </Button>
            </DialogClose>
            <Button
              variant='secondary'
              className='w-full font-medium'
              onClick={startNowSubscription}
              disabled={loadingStartSubsNow}
            >
              {loadingStartSubsNow ? "Activating, Please Wait..." : "Activate"}
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
